module.exports = __webpack_public_path__ + "static/media/38.67816066.png";